



































































































































import {Component, Vue} from 'vue-property-decorator';
import JdsCandidateBubble from "@/design-system/constructs/CandidateBubble/JdsCandidateBubble.vue"
import JdsCandidateBubbleColumnLayout
    from "@/design-system/constructs/CandidateBubble/JdsCandidateBubbleColumnLayout.vue"
import JdsPipeline from "@/design-system/patterns/Pipeline/JdsPipeline.vue"
import JdsWorkbench from "@/design-system/patterns/Workbench/JdsWorkbench.vue"
import JdsPipelineStage from "@/design-system/patterns/Pipeline/JdsPipelineStage.vue"
import JdsPipelineCard from "@/design-system/patterns/Pipeline/JdsPipelineCard.vue"
import JdsNotificationBadge from "@/design-system/constructs/NotificationBadge/JdsNotificationBadge.vue"
import {Candidate} from '@/jds';
import moment from 'moment';
import {uuidv4} from '@/design-system/utilities/Uuid';
import {getAstronaut} from '@/design-system/utilities/KerbalNameGenerator';
import JdsWorkbenchHeader from "@/design-system/patterns/Workbench/JdsWorkbenchHeader.vue"
import JdsWorkbenchToolbar from "@/design-system/patterns/Workbench/JdsWorkbenchToolbar.vue"
import JdsPipelineStageBadge from "@/design-system/patterns/Pipeline/JdsPipelineStageBadge.vue"
import JdhHeightTransition from "@/design-system/shared/JdhHeightTransition.vue"
import JdsDropdownMenu from "@/design-system/patterns/DropdownMenu/JdsDropdownMenu.vue"
import JdsDropdownMenuItem from "@/design-system/patterns/DropdownMenu/JdsDropdownMenuItem.vue"
import JdsWorkbenchBackButton from "@/design-system/patterns/Workbench/JdsWorkbenchBackButton.vue"
import JdsPipelineCardDrawer from "@/design-system/patterns/Pipeline/JdsPipelineCardDrawer.vue"


interface Foo {
    bar: string
}

@Component({
    components: {
        JdsPipelineCardDrawer,
        JdsWorkbenchBackButton,
        JdsDropdownMenuItem,
        JdsDropdownMenu,
        JdhHeightTransition,
        JdsPipelineStageBadge,
        JdsWorkbenchToolbar,
        JdsWorkbenchHeader,
        JdsNotificationBadge,
        JdsCandidateBubbleColumnLayout,
        JdsCandidateBubble,
        JdsPipelineCard,
        JdsPipelineStage,
        JdsWorkbench,
        JdsPipeline
    }
})
export default class JdpJobCandidates extends Vue {
    candidates: Array<typeof Candidate & { id: string, stage: string }> = [];
    stages: Array<string> = [];

    selecting = false
    selected = []

    get candidatesByPipeline() {
        const lookup = ['A+', 'A', 'B', 'C', undefined]

        return this.candidates.reduce(( obj, candidate ) => {
            obj[candidate.stage] = [
                ...(obj[candidate.stage] ?? []),
                candidate,
            ]

            obj[candidate.stage].sort((candidate1, candidate2) => {
                if (lookup.indexOf(candidate1.score) < lookup.indexOf(candidate2.score)) return -1
                if (lookup.indexOf(candidate1.score) > lookup.indexOf(candidate2.score)) return 1
                return 0
            })

            return obj
        }, Object.fromEntries(this.stages.map(stageId => [stageId, []])))
    }

    mounted() {
        const randId = () => {
            return uuidv4().replace('-',' ')
        }
        // this.stages = ['Myyjien/korjaamopäälliköiden hylkäämät tai itse hakunsa keskeyttäneet --> "kiitos, ei kiitos" viesti lähtenyt 13.4.',
        //     'Hakija perui hakemuksen - ei valittu (ei laiteta viestiä rekrytoinnin etenemisestä)',
        //     'Hylätty hakemuksen perusteella --> "Kiitos, ei kiitos"- viesti lähetetty 22.3.',
        //     'ästä eteenpäin jokaiselle vaiheen henkilölle ilmoitettu ei kiitos ->',
        //     'kommt grundsätzlich - zumindest als Mitarbeiter bei Gresi -  infrage !!',
        //     'angeschrieben, da keine Telefonnummer oder telefonisch nicht erreicht',
        //     'Odottaa (B ja C), saanyt hylkyviestin tai on mukana toisessa haussa',
        //     'työelämäkouluttajaksi: ylempi tutkinto, pedat, kokemus mamuista',]

        this.stages = [
            'Inbox',
            'Nicht erreicht / Kontaktphase',
            'Telefongespräch geführt',
            'Erstgespräch vereinbart / geführt',
            'Einstellen',
            'Abgelehnt / Abgesagt / Keine Eignung',
        ]

            for (let candidateCount = 0; candidateCount <  30; candidateCount++) {
                let tags = []
                while(Math.random() < 0.6) {
                    let color = "#xxxxxx".replace(/x/g, y=>(Math.random()*16|0).toString(16))
                    tags.push({name: `Tag: ${color}`, color})
                }

                const stage = ~~(Math.random()*this.stages.length)
                const enteredAt =
                    Math.random() > 0.66 ?
                    Math.random() > 0.5 ?
                        moment().subtract(7, 'days')
                        : moment().subtract(96, 'hours')
                        : moment().subtract(5, 'hours')
                this.candidates.push({
                    id: uuidv4(),
                    stage: this.stages[stage],
                    name: getAstronaut(),
                    lastInteraction: moment().startOf('week'),
                    enteredAt: enteredAt,
                    score: ['A+', 'A', 'B', 'C', undefined][~~(Math.random()*5)],
                    tags,
                    counters: {
                        emails: Math.floor(Math.random()* 10),
                        comments: Math.floor(Math.random()* 10),
                        files: Math.floor(Math.random()* 10),
                    },
                    additionalFormState: [undefined, 'sent', 'replied'][~~(Math.random()*3)],

                    badges: {
                        email: Math.random() > 0.8
                    },

                    reactions: {
                        heart: Math.random() > 0.8 ? 8 - Math.ceil(Math.pow(Math.random() * 2, 3)) : 0,
                        thumbs: Math.random() > 0.8 ? 8 - Math.ceil(Math.pow(Math.random() * 2, 3)) : 0,
                        meh: Math.random() > 0.8 ? 8 - Math.ceil(Math.pow(Math.random() * 2, 3)) : 0,
                    },

                     called: [undefined, 'pass', 'fail', 'warn'][~~(Math.random()*4)]
                });
            }
    }

    moveCandidates({cardIds, targetId}: { cardIds: string[], targetId: string|null }) {
        if (targetId === null) return

        cardIds
            .forEach(targetCandidate => {
                const candidate = this.candidates.find(candidate => candidate.id === targetCandidate);
                candidate.stage = targetId;
            })
    }
}
